import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

export default function MirasHukuku() {
  const serviceFeatures = [
    {
      title: 'Miras Paylaşımı',
      description: 'Miras paylaşımı ve mirasçılar arası anlaşmazlıklar',
      icon: 'ri-pie-chart-line'
    },
    {
      title: 'Mirasın Reddi',
      description: 'Miras reddi işlemleri ve hukuki süreçler',
      icon: 'ri-close-circle-line'
    },
    {
      title: 'Veraset ve İntikal İşlemleri',
      description: 'Veraset ve intikal işlemlerinin yürütülmesi',
      icon: 'ri-file-transfer-line'
    },
    {
      title: 'İzale-i Şüyu Davaları',
      description: 'Ortaklığın giderilmesi ve ecrimisil davaları',
      icon: 'ri-group-line'
    }
  ];

  const additionalServices = [
    'Tasarrufların İptali ve Muris Muvazaasına ilişkin davalar',
    'Veraset Davası (veraset ilamı almak, veraset belgesinin iptali)'
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-slate-900 text-white py-20">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/dea8c2030a7c0aee66d0c447658f8126.jpg')`
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 to-slate-900/70"></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="flex items-center mb-4 animate-fade-in-up">
              <Link to="/services" className="text-gray-300 hover:text-white transition-colors font-poppins font-light">
                Hizmetler
              </Link>
              <i className="ri-arrow-right-s-line mx-2 text-gray-400"></i>
              <span className="text-white font-poppins font-light">Miras Hukuku</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6 animate-fade-in-up font-poppins" style={{ animationDelay: '0.1s' }}>
              Miras Hukuku
            </h1>
            
            <p className="text-xl text-gray-200 leading-relaxed animate-fade-in-up font-poppins font-light" style={{ animationDelay: '0.2s' }}>
              Miras paylaşımı, veraset işlemleri, miras davaları ve miras hukuku danışmanlığı 
              konularında uzman hukuki hizmetler sunuyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Service Features */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 animate-fade-in-up font-poppins">
              Miras Hukuku Hizmetlerimiz
            </h2>
            <div className="w-16 h-0.5 bg-slate-900 mx-auto mb-6"></div>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto animate-fade-in-up font-poppins font-light" style={{ animationDelay: '0.1s' }}>
              Miras hukuku alanında kapsamlı hizmetler
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {serviceFeatures.map((feature, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-lg border border-gray-100 p-8 hover:shadow-xl transition-all duration-300 animate-fade-in-up hover-lift"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-16 h-16 bg-slate-900 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${feature.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-4 font-poppins">
                  {feature.title}
                </h3>
                <p className="text-slate-600 leading-relaxed font-poppins font-light">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          {/* Additional Services */}
          <div className="bg-slate-50 rounded-lg p-8 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            <h3 className="text-2xl font-bold text-slate-900 mb-6 font-poppins">
              Diğer Hizmetlerimiz
            </h3>
            <ul className="space-y-3">
              {additionalServices.map((service, index) => (
                <li key={index} className="flex items-start text-slate-600 font-poppins font-light">
                  <i className="ri-check-line text-slate-900 mr-3 mt-1 flex-shrink-0"></i>
                  {service}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Detailed Content */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-slate-900 mb-8 animate-fade-in-up font-poppins">
            Miras Hukuku Danışmanlığımız
          </h2>
          
          <div className="space-y-6 text-slate-600 leading-relaxed font-poppins font-light">
            <p className="animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
              Miras hukuku alanında uzman kadromuzla, mirasçıların haklarının korunması ve 
              miras süreçlerinin hukuka uygun şekilde yürütülmesi için kapsamlı hukuki 
              hizmetler sunuyoruz. Miras paylaşımından veraset işlemlerine kadar tüm 
              süreçlerde yanınızdayız.
            </p>
            
            <p className="animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
              Miras bırakanın tasarruflarının geçerliliği, mirasçılar arası anlaşmazlıklar, 
              saklı pay ihlalleri ve miras paylaşımı konularında hukuki danışmanlık ve 
              temsil hizmeti veriyoruz. Veraset ve intikal işlemlerinin doğru şekilde 
              yürütülmesini sağlıyoruz.
            </p>
            
            <p className="animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
              İzale-i şüyu davaları, ecrimisil talepleri, tasarrufların iptali ve muris 
              muvazaası davalarında deneyimli kadromuzla müvekkillerimizi temsil ediyoruz. 
              Miras hukuku alanındaki karmaşık süreçlerde profesyonel destek sağlıyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4 animate-fade-in-up font-poppins">
            Miras Hukuku Danışmanlığı
          </h2>
          <p className="text-lg text-gray-200 mb-8 animate-fade-in-up font-poppins font-light" style={{ animationDelay: '0.1s' }}>
            Miras haklarınızı koruyun, uzman desteği alın
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <button className="bg-white text-slate-900 px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors font-poppins font-semibold whitespace-nowrap cursor-pointer">
              Miras Danışmanlığı
            </button>
            <button className="border border-white text-white px-8 py-3 rounded-lg hover:bg-white hover:text-slate-900 transition-colors font-poppins font-semibold whitespace-nowrap cursor-pointer">
              Hukuki Destek
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}